/**
 * Возвращает имя изображения из его пути
 * @param {string} src
 * @returns {string}
 */
export const getImageName = (src: string) => src.substring(src.lastIndexOf('/') + 1);
